export const eng = {
  _LOGIN: {
    _EMAIL: "Email",
    _PASSWORD: "Password",
    _REMEMBER: "Remember me",
    _LOGIN: "LOGIN",
    _SIGNUP: "Sign up",
    _FORGOTPASSWORD: "Forgot your password?",
    _NOACCOUNT: "Don't have an account?",
    _ERROR_EMAIL: "Apparently you are not registered! Try again.",
    _ERROR_PASSWORD: "Incorrect password",
    _SUCCESS: "Login Success",
  },
  _REGISTER: {
    _REGISTER: "Register Account",
    _NAME: "Username",
    _EMAIL: "Your email",
    _PASSWORD: "Your password",
    _CONFIRMPASSWORD: "Confirm Password",
    _WHATSAPP: "WhatsApp",
    _TELEGRAM: "Telegram (optional)",
    _HAVEACCOUNT: "I have an account",
    _ERROR_REFERAL: "Wrong referral code",
    _ERROR_EMAIL: "This email already exists",
    _SUCCESS: "Registration Success",
  },
  _SIDEBAR: {
    _PAGES: "Pages",
    _OPEN: "Open sidebar",
    _DASHBOARD: "Home",
    _NETWORK: "Network",
    _FINANCE: "Wallet",
    _PACKAGES: "Plans",
    _SIGNOUT: "Sign Out",
    _LANGUAGE: "Language",
    _PROFILE: "Profile",
    _AUTH: "Authenticator",
  },
  _DASHBOARD: {
    _TITLE: "Balance",
    _TITLE2: "Deposit",
    _TITLE3: "Total Earnings",
    _TITLE4: "Unilevel Earnings",
    _TITLE5: "Infinity Range Bonus",
    _TITLE6: "Plan",
    _TITLE7: "Unilevel Start-Up Bonus",
    _TITLE8: "Binary Bonus",
    _TITLE9: "Binary Matching Bonus",
    _TITLE10: "COPY TRADING Residual Bonus",
    _TOTAL: "Total",
    _TABLE3: "Packages List",
    _START: "Start",
    _FINISH: "Finish",
    _STATUS: "Status",
    _STATUS_ACTIVE: "Active",
    _STATUS_INACTIVE: "Inactive",
    _CURRENT: "Current",
    _UPGRADE: "Upgrade",
    _COPYMESSAGE: "Copy successful",
    _NOTIFICATION1: "New Deposit",
    _NOTIFICATION2: "Cryptotradex Profit",
    _NOTIFICATION3: "Unilevel Profit",
    _NOTIFICATION4: "Range Infinite",
    _NOTIFICATION5: "Purchase Package",
    _NOTIFICATION7: "Recurring Direct Referral Bonus",
    _PREV: "Previous",
    _NEXT: "Next",
    _TABLE4_A: "Operation",
    _TABLE4_B: "Profit",
    _TABLE4_C: "ROI",
    _TABLE4_D: "Date",
    _SHARED: "Share your referral link",
    _TITLESHARED: "Referral Link",
    _TEXTSHARED:
      "Share your binary referral link and choose the position where you want to place your invitee, or let it be assigned randomly.",
    _RANDOM: "Random",
    _CTFLIX:
      "Get trained in trending and high-profit business models with Web3.",
    _SIGNAL: "Get the best signals from one place and multiply your capital.",
    _COPY:
      "Forget about tracking entries and exits—copy all trades with one click.",
    _CTXII:
      "Multiply your capital X12 automatically in partnership with CTX. Contact the person who introduced you to this opportunity.",
    _ENTER: "Enter",
    _INPOSITION: "Positioning stage",
  },
  _FINANCE: {
    _DEPOSIT: "Deposit",
    _QR: "Scan the following QR or copy the address",
    _NETWORK: "Network",
    _INSTRUCTIONS: "Instructions for Sending SOLANA (SOL)",
    _STEP1: "Make sure the selected network is SOLANA.",
    _STEP2: "Send the amount of SOLANA to the following wallet address.",
    _COPY: "Copy",
    _DISCLAIMER:
      "Disclaimer: We are not responsible for transactions made outside the SOLANA network or for sending cryptocurrencies other than SOLANA. Any loss of funds due to these errors will be the sole responsibility of the sender.",
    _TABLE1: "Deposit History",
    _TABLE1_A: "Order",
    _TABLE1_B: "Amount",
    _TABLE1_C: "Date",
    _TABLE1_D: "Status",
    _SUCCESS: "The package was added successfully",
    _COPYMESSAGE: "Wallet address copied successfully",
  },
  _PACKAGES: {
    _ATTENTION:
      "Attention: You have a corporate account. By purchasing a package, you will restart the account and all its benefits.",
    _PACKAGES: "Select the best plan for you",
    _SUBTITLE: "You have 8 options",
    _BALANCE: "Balance Deposit",
    _PACKAGE: "Package ",
    _PACKAGE_1: "You will earn up to level ",
    _PACKAGE_2: "Earn up to",
    _PACKAGE_3: "Week ROI",
    _BUTTON1: "Filled",
    _BUTTON2: "Buy",
    _CALCULATE: "Calculate Plan",
    _RECHARGE: "You don't have enough money, recharge your wallet",
    _PACKAGEMESSAGE: "You must purchase a higher package",
    _SUCCESS: "The package was added successfully",
    _UPDATE: "Package upgrade price",
    _BASIC: "Basic",
    _INTERMEDIATE: "Basic + Intermediate",
    _ADVANCED: "Basic + Intermediate + Advanced",
    _COMPLETED: "Completed",
    _SIGNALS: "CTX Signals",
    _COPY: "CTX CopyTrading",
  },
  _NETWORK: {
    _TODAY: "Today",
    _AVAILABLE: "Available",
    _WITHDRAW: "Total Withdrawn",
    _SEARCHLABEL: "Email Search",
    _SEARCH: "Search",
    _NETWORK: "Network",
    _DIRECTS: "Directs",
    _SUCCESS: "Search Successful",
    _ERROR: "Not part of your tree.",
    _LEVEL: "Level",
    _USERS: "Users",
    _AMOUNT: "Amount",
    _USERNAME: "Username",
    _EMAIL: "Email",
    _WHATSAPP: "WhatsApp",
    _PACKAGE: "Package",
    _LEFT: "Left",
    _RIGHT: "Right",
    _TOTALLEFT: "Cumulative Total Left",
    _TOTALRIGHT: "Cumulative Total Right",
    _BINARYTEXT:
      "To place your referral in the binary tree, press and hold the corresponding button (left or right). Remember that this action can only be performed once, so we recommend carefully reviewing your selection before confirming.",
    _BINARYSUCCESS: "Transaction completed successfully",
    _BINARYLOADING: "Loading...",
    _SEARCHFORUSERNAME: "Search for username",
    _TANK: "Direct referral tank",
  },
  _PROFILE: {
    _TITLE: "Profile",
    _NAME: "Your name",
    _EMAIL: "Your email",
    _WHATSAPP: "WhatsApp",
    _CURRENTPASSWORD: "Current password",
    _PASSWORD: "New password",
    _CONFIRMPASSWORD: "Confirm new password",
    _WALLET: "Withdrawal address",
    _ACTION: "Edit",
    _TIPS: "Tips",
    _TIPS_1: "The name must be legible and not exceed 20 characters.",
    _TIPS_2:
      "The password must include numbers, letters, and symbols; the more complex, the better.",
    _TIPS_3:
      "The email cannot be changed. If you need to make a change, please write to support.",
    _TIPS_4:
      "The withdrawal address can only be modified with a 2-factor authenticator, which must be enabled previously.",
    _ERROR_PASSWORD: "Previous password error",
    _SUCCESS: "Profile updated successfully",
    _MIN: "Minimum withdrawal",
    _UPDATE: "Update Profile",
  },
  _RECOVERPASSWORD: {
    _RECOVERPASSWORD: "Forgot your password?",
    _EMAIL: "Your email",
    _BUTTON: "Send email",
    _MESSAGE: "Your password was sent to your email",
    _ERROR_EMAIL: "This email is not registered",
  },
  _GLOBALV: {
    _TITLE: "GV",
    _CURRENT: "Current Rank",
    _NEXT: "Next Rank",
    _SILVER: "Silver",
    _GOLD: "Gold",
    _RUBY: "Ruby",
    _EMERALD: "Emerald",
    _DIAMOND: "Diamond",
    _DIAMONDB: "Diamond Blue",
    _DIAMONDBB: "Diamond Black",
    _NONE: "None",
  },
  _AUTH: {
    _TITLEDEFAULT: "Change withdrawal wallet",
    _TITLE: "Step 1",
    _TITLE2: "Step 2",
    _TITLE3: "Step 3",
    _STEP1: "Download and install the authenticator on your device",
    _STEP2: "Scan the code to save",
    _FORMEMAIL: "Email Verification",
    _FORMHELPEMAIL: "Enter the 6-digit verification code sent to",
    _FORMHELPAUTH: "Enter the 6-digit code generated by the Authenticator App",
    _FORM1: "Pin by Authenticator",
    _FORM2: "Withdrawal address",
    _FORMMIN: "The withdrawal address must be 34 characters long",
    _FORMCODESEND: "Code Send",
    _VERIFF: "Veriff",
    _ACTION: "Check and Save",
    _ERROR: "Error, try again.",
    _SUCCESS: "Change successful",
    _RETRYOTP: "Error sending the code, try again.",
    _SENDOTP: "Code sent successfully",
    _SUCCESSOTP: "OTP Satisfactorily Verified",
    _SUCCESSAUTH2F: "Auth2fa Satisfactorily Verified",
    _ERRORCODE: "Invalid code try again",
  },
  _COUNTDOWN: {
    _TITLE: "Next cut:",
    _DAYS: "Days",
    _HOURS: "Hours",
    _MINUTES: "Minutes",
    _SECONDS: "Seconds",
  },
  _WITHDRAWAL: {
    _TITLE: "Withdrawal Transactions",
    _ERRORPROCESS:
      "You already have another withdrawal in process, wait a few minutes",
    _ERRORWALLET: "You must first set up your Solana withdrawal wallet",
    _ERRORBALANCE: "Negative balance is reinitiated again.",
    _ERROROTHER: "Error making withdrawal, please try again.",
    _SUCCESS:
      "Successful withdrawal. It will arrive in your wallet in minutes.",
  },
  _SYSTEM: {
    _SYSTEM: "System",
    _GLOBAL: "Global",
    _INVESTMENT: "Withdraw investment",
    _INVESTMENTTEXT:
      "Remember that you will have a penalty of 35% of your investment",
    _ACCELERATE: "Accelerate",
    _REPORT: "Cryptotradex Investment Report",
    _PARNERT: "Sponsor information",
  },
  _WITHDRAWINVESTMENT: {
    _TITLE: "Withdraw Investment",
    _MESSAGE:
      "Withdrawing your capital now involves a 35% operational fee - accumulated earnings, and it will be processed within 24 hours. If you do this, you will stop its immediate growth potential. Decide with a long-term vision!",
    _BUTTON: "Withdraw",
    _BUTTONWAIT: "Withdrawal in process",
  },
  _SIGNAL: {
    _NEWS: "New",
    _SIGNALS: "Signals",
    _CHAT: "Exclusive chat",
    _OPEN: "Open",
    _CLOSED: "Closed",
    _PRICEENTRY: "Entry price",
    _PRICEEND: "Closing price",
    _INITIAL: "Initial price",
    _MAXIMUN: "Maximum price ATH",
    _DATEATH: "ATH date",
    _MKCAP: "Market Cap",
  },
  _ACADEMY: {
    _NEWS: "New",
    _TITLE: "Academy",
    _WHATIS: "What is Cryptotradex Academy?",
    _DESCRIPTION:
      "Learn about cryptocurrencies, wallets, memes, and Web3 with our online platform designed for all levels.",
    _ACTION1: "Go to the Academy",
    _DISABLED: "A minimum deposit of 500 USD is required",
    _TITLANDING: "Become an expert in Cryptomemes",
    _DESCRIPTIONLANDING:
      "Access exclusive tutorials from the BRETT package and learn to master the world of MEMECOINS.",
    _ACTIONLANDING: "Sign up now and start learning!",
    _WHATCOURSES: "What courses will you get?",
    _RECOMMENDS: "Recommended videos",
  },
  _FREE: {
    _FREE: "Free",
    _FREEFOR: "FREE FOR A LONG TIME",
    _SIGNALS: "Go to Signals",
    _LINK: "Community Link",
    _TITLE:
      "Join our WhatsApp community to get immediate and real-time information",
    _DISCLAIMER: "Disclaimer",
    _CHANNEL: "Go to Channel",
    _TEXTDISCLAIMER:
      "These signals have an execution period, at the moment we publish them in our signals group is when we achieve the demonstrated profit.",
    _LEGEND: "Legend",
    _NAME: "Token Name",
    _URL: "DexScrenner Link",
    _START: "Start Time",
    _END: "End Time",
    _PROFIT: "Profit",
    _VER: "Go",
  },
  _CTFLIX: {
    _BASIC: "Basic",
    _INTERMEDIATE: "Intermediate",
    _ADVANCED: "Advanced",
    _MODULE0: "Initial Module",
    _MODULE1: "Module 1 Crypto Security",
    _MODULE2: "Module 2 Coinbase",
    _MODULE3: "Module 3 Bybit",
    _MODULE4: "Module 4 Binance",
    _MODULE5: "Module 5 Exchanges",
    _MODULE6: "Module 6 Basic Tools",
    _MODULE7: "Module 7 Rabby Wallet",
    _MODULE8: "Module 8 Phantom Wallet",
    _MODULE9: "Module 9 Trezor",
    _MODULE10: "Module 10 Ledger",
    _MODULE11: "Module 11 Onchain Tools",
    _MODULE12: "Module 12 OnChain Analysis",
    _MODULE13: "Module 13 GMGN",
    _MODULE14: "Module 14 Advanced Dexscreener",
    _MODULE15: "Module 15 Bull Bot x NEO",
    _ALLLANGUAGE: "All languages",
    _ALLTYPES: "All types",
    _ALLLMODULES: "All modules",
    _REQUIREDBASIC:
      "Upgrade your plan and access exclusive modules like: Crypto Security, Coinbase, Bybit, Binance, and more than 54 educational videos!",
    _REQUIREDINTERMEDIATE:
      "Don't miss out on key modules like: Exchanges, Basic Tools, and the use of Wallets like Rabby Wallet, Phantom, Trezor, and Ledger! Upgrade your plan and keep access to all the content.",
    _REQUIREDADVANCED:
      "Don't lose access to advanced tools like: Onchain Analysis, GMGN, DexScreener, and learn to use the Bull Neo Bot! Upgrade your plan to explore the full potential of these platforms.",
  },
  _COPY: {
    _TITLE: "My Copy Trading Wallet",
    _MIN: "Minimum deposit 300 USD",
    _BALANCE: "Balance",
    _TYPE: "Type",
    _CONSERVE: "Conservative",
    _CONSERVEDESCRIPTION: "Low risk, stability, and capital preservation.",
    _MODERADE: "Moderate",
    _MODERADEDESCRIPTION: "Balance between risk and growth.",
    _ADVANCED: "Aggressive",
    _ADVANCEDDESCRIPTION: "High risk, high potential returns, high volatility.",
    _SLIPPAGE: "Slippage",
    _SUPPLY: "Amount to trade",
    _TIME: "Time",
    _STATISTICS: "Statistics",
    _DISCLAIMER:
      "To activate the copy trading system, an initial deposit of <strong class='text-red-300'>300 USD</strong> is required. Once this step is completed, the system will go through a setup phase that can take between 24 to 72 business hours. <br/> <br/> After this process, the system will start operating in real time, replicating the strategies of our trading team. <br/> <br/> It is important to note that we are not obligated to perform trades every day. We only execute trades when the market conditions are favorable, avoiding unnecessary risks. <br/> <br/> This system does not guarantee constant returns. Users accept that gains and losses are a natural part of market behavior, which is free and not manipulated. No claims will be accepted in case of losses. <br/> <br/> However, we are deeply proud of our knowledge and experience, and we act responsibly in every decision we make. <br/> <br/> Finally, the entire copy trading process includes a manual configuration and verification stage, in which user data and system information are validated before activation.",
    _ACTION: "Actions",
    _PORTFOLIO: "Portfolio",
    _CAPITAL: "Withdraw Capital",
    _EARNINGS: "Withdraw Earnings",
    _CONNECTION: "Connection",
  },
  _NOTICE: {
    _NOTICE: "Estelar Notice",
    _CRYPTOCARD: "CryptoCard is coming",
    _DESCRIPTION: "Our card will, get ready for a total experience.",
    _NEW: "New member?",
    _DISCOVERY: "Discover everything we have for",
    _YOU: "you",
    _MYBUSINESS: "My business",
    _MYPRODUCTS: "My products",
  },
  _STATISTICS: {
    _FROM: "From",
    _UNTIL: "Until",
    _NUMBERSOPERATIONS: "Number of transactions",
  },
};
